<template>
    <form class="report-item report-item--edit" @submit="saveConsultation">
        <div class="report-item__column report-item__column--case">
            <div class="report-item__status">
                <router-link :to="`/zgloszenie/${report.id}`">
                    <div :class="`report-item__status-icon ${ report.case.isReporter ? 'report-item__status-icon--my' : '' }`">
                        <IconFileSearch class="report-item__icon" alt=""/>
                    </div>
                </router-link>
            </div>
            <div class="report-item__details">
                <div class="report-item__number">{{ report.case.number }}</div>
                <div class="report-item__gender">
                    <IconVenus v-if="report.patient.gender === 'K'" class="report-item__gender-icon" />
                    <IconMars v-else class="report-item__gender-icon" />
                    <span>{{ report.patient.gender }}</span>
                </div>
                <div class="report-item__age">WIEK: {{ report.patient.age }}</div>
            </div>
        </div>

        <div class="report-item__column report-item__column--pwz">{{ report.doctor.pwz }}</div>

        <div class="report-item__column report-item__column--date">
            <div class="report-item__date">{{ formatDate(report.case.createdAt) }}</div>
            <div :class="`report-item__relative-time report-item__relative-time--${relativeDate(report.case.createdAt)}`">
                <span><b>{{ translatedRelativeDate(report.case.createdAt) }}</b> temu</span>
            </div>
        </div>

        <div class="report-item__column report-item__column--surgery">
            <select class="report-list__field" v-model.number="editedReport.surgicalEvaluation.code">
                <option
                    v-for="(label, code) in surgicalEvaluation"
                    :value="code"
                    :key="code"
                >{{ label }}</option>
            </select>
            <textarea
                class="report-list__field"
                v-model="editedReport.surgicalEvaluation.note"
                v-if="editedReport.surgicalEvaluation.code === 4"
            ></textarea>
        </div>

        <div class="report-item__column report-item__column--forecast">
            <input
                class="report-list__field"
                type="date"
                :value="bindDate(editedReport.expectedSurgeryDate)"
                @input="editedReport.expectedSurgeryDate = $event.target.value"
            />
        </div>

        <div class="report-item__column report-item__column--rating">
            <select class="report-list__field" v-model.number="editedReport.chemotherapyEffectiveness">
                <option
                    v-for="(label, code) in chemotherapyEffectiveness"
                    :value="code"
                    :key="code"
                >{{ label }}</option>
            </select>
        </div>

        <div class="report-item__column report-item__column--last">
            <input
                class="report-list__field"
                type="date"
                :value="bindDate(editedReport.lastChemotherapyCycleAt)"
                @input="editedReport.lastChemotherapyCycleAt = $event.target.value"
            />
        </div>

        <div class="report-item__column report-item__column--risk">
            <select class="report-list__field" v-model.number="editedReport.procedureRisk.code">
                <option
                    v-for="(label, code) in procedureRisk"
                    :value="code"
                    :key="code"
                >{{ label }}</option>
            </select>
            <textarea
                class="report-list__field"
                v-model="editedReport.procedureRisk.note"
                v-if="editedReport.procedureRisk.code === 2"
            ></textarea>
        </div>

        <div class="report-item__column report-item__column--inline">
            <button class="report-item__button report-item__button--save">Zapisz</button>
        </div>

        <div class="report-item__column report-item__column--edit">
            <button type="button" class="report-item__button report-item__button--cancel" @click="cancelConsultation">Anuluj</button>
        </div>
    </form>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from "vuex";
import { IconFileSearch, IconVenus, IconMars } from '@/components/ui/icons'
import { surgicalEvaluation, chemotherapyEffectiveness, procedureRisk } from "./ReportCodeTranslations.js"
import utils from "./ReportUtils"

export default {
    name: "ReportListItemEdit",
    components: {
        IconFileSearch,
        IconVenus,
        IconMars,
    },
    computed: mapGetters({
        userData: "getUserData",
        securedRequestHeader: "getSecuredRequestHeader",
    }),
    props: {
        report: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            editedReport: {
                expectedSurgeryDate: this.report.case.expectedSurgeryDate,
                chemotherapyEffectiveness: this.report.case.chemotherapyEffectiveness,
                lastChemotherapyCycleAt: this.report.case.lastChemotherapyCycleAt,
                procedureRisk: {...this.report.case.procedureRisk},
                surgicalEvaluation: {...this.report.case.surgicalEvaluation},
            },
            surgicalEvaluation,
            chemotherapyEffectiveness,
            procedureRisk,
        }
    },
    methods: {
        ...utils,
        bindDate(date) {
            return moment(date).format("YYYY-MM-DD")
        },

        cancelConsultation(event) {
            event.preventDefault();

            this.$emit("update-report", this.editedReport);
            this.report.status = this.report.originalStatus;
        },

        async saveConsultation(event) {
            event.preventDefault();

            try {
                const url = `${process.env.VUE_APP_API_URL}/medical-case/${this.report.id}/consultation-data`;
                const response = await axios.put(url, this.editedReport, { headers: this.securedRequestHeader })

                if (response.status === 200) {
                    this.$emit("update-report", this.editedReport);
                    this.report.status = "CASE_ACTIVE";
                }
            } catch (error) {
                console.log(error);
            }
        },
    }
};
</script>

<style lang="scss">

.report-item--edit {
    align-items: flex-start;
}

.report-item__button {
    padding: 11px 15px;
    margin: 15px 0;
    &--cancel {
        background-color: #ffffff;
        color: grey;
    }
    &--save {
        background-color: #94c120;
        color: white;
    }
}

textarea.report-list__field {
    margin-top: 10px;
}

</style>
